import {useQuery, gql} from "@apollo/client";
import {useContext} from "react";
import {LocaleContext} from "../store/providers/LocaleProvider";
import {useLogger} from "./useLogger";

const QUERY = gql`
query getArticles($slug: String!, $locale: String!) {
  pageCollection(limit: 1, where: { slug: $slug }, locale: $locale) {
    items {
      slug
      content {
          ... on PageBlogPost {
          sys{
            id
          }
          contentfulMetadata{
            tags{
              id
            }
          }
          teaserOfTheArticle
          bodyOfTheArticle{
            json
            links {
              assets {
                block {
                  sys {
                    id
                  }
                  url
                  description
                }
              }
              entries {
                inline {
                  ... on HtmlComponents {
                    sys{
                      id
                    }
                    id
                    label
                    type,
                    title
                  }
                }
                block {
                  ... on HtmlComponents {
                    sys{
                      id
                    }
                    id
                    label
                    type,
                    title
                  }
                }
              }
            }
          }
          headerPicture{
            title
            url
            description
          }
          titleOfTheArticle
          publishDate
          bloggerProfile{
            names
            additionalInfo
            description {
              json
            }
            picture {
              title
              url
            }
          }
          category
        }
      }
      seo {
        ... on Seo {
          title
          description
        }
      }
    }
  }
}`;

export const useArticleBySlug = (slug) => {
    const {localeUppercase} = useContext(LocaleContext)[0];
    const {logger} = useLogger();
    const {loading, error, data} = useQuery(QUERY, {variables: { slug: slug, locale: localeUppercase}, errorPolicy: "all", fetchPolicy: "no-cache"});

    const componentData = data?.pageCollection?.items[0]?.content;
    const articleSEOData = data?.pageCollection?.items[0]?.seo;
    const assetsMap = new Map();
    const htmlComponentsMap = new Map();

    data?.pageCollection?.items[0]?.content?.bodyOfTheArticle?.links?.assets?.block?.forEach((asset) => {
        assetsMap.set(asset?.sys?.id, {url: asset?.url, description: asset?.description});
    });

    data?.pageCollection?.items[0]?.content?.bodyOfTheArticle?.links?.entries?.inline?.forEach((entry) => {
        htmlComponentsMap.set(entry?.sys?.id, {id: entry?.id, label: entry?.label, type: entry?.type});
    });

    data?.pageCollection?.items[0]?.content?.bodyOfTheArticle?.links?.entries?.block?.forEach((entry) => {
        htmlComponentsMap.set(entry?.sys?.id, {id: entry?.id, label: entry?.label, type: entry?.type});
    });

    if (error?.message) {
        logger(error?.message, "error", "useArticleBySlug", error?.stack);
    }

    return {
        componentData,
        articleSEOData,
        assetsMap,
        htmlComponentsMap,
        loading,
        error
    };
};
